export default __webpack_public_path__ + "static/media/mp_payment.f6c5264d.svg";